export default (() => ({}));